import { addTextConnectLink } from '@frontend/assets';
import appConfig from '@frontend/env';
import { useTranslation } from '@frontend/i18n';
import { Text } from '@frontend/design-system';
import { CopyHelper } from '../CopyHelper';
import * as styles from './styles';

interface Props {
  locationId: string;
}

export const DirectToWebPortal = ({ locationId }: Props) => {
  const { t } = useTranslation('schedule', { keyPrefix: 'text-connect' });

  return (
    <>
      <Text css={styles.textConnectTextSpacing}>
        {t(
          'When customers wish to send a message to your office, they are redirected from your website (or anywhere you have a web presence, ex: Facebook or Google business pages) to a simple website provided by Weave with a page they can use to contact your office.'
        )}
      </Text>

      <img
        alt={t('Your Google Page or Your Facebook Page and the Online Scheduling Portal')}
        css={styles.addTextConnectWidgetImg}
        src={addTextConnectLink}
      />

      <hr css={styles.divider} />

      <Text as='h3' css={styles.howToSetUp} weight='bold'>
        {t('How To Set Up')}
      </Text>

      <Text css={styles.textConnectTextSpacing}>
        {t(
          "Paste the URL below as a link into whichever online source you'd prefer. This may be a Facebook or Google business page, a button or link on your own business website, or any other web or social media outlet you have."
        )}
      </Text>

      <Text css={styles.textConnectTextSpacing}>
        {t(
          'When customers click the link, they will be directed to a web portal where they will be able to send a message directly to your office.'
        )}
      </Text>

      <Text css={styles.textConnectTextSpacing}>{t('Click to copy the url')}</Text>

      <CopyHelper helperText='' copyText={`${appConfig.APP_BOOK_BASE_URL}/${locationId}/text-connect/contact-info`} />
    </>
  );
};
